// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var LineHeaderTheme;
(function (LineHeaderTheme) {
    LineHeaderTheme["Light"] = "light";
    LineHeaderTheme["Dark"] = "dark";
})(LineHeaderTheme || (LineHeaderTheme = {}));
/**
 * This enum is needed for better TypeScript experience
 * within the `LineHeader.stories.ts` file.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var LineHeaderPropNames;
(function (LineHeaderPropNames) {
    LineHeaderPropNames["IsBold"] = "isBold";
    LineHeaderPropNames["ShowPointer"] = "showPointer";
    LineHeaderPropNames["Site"] = "site";
    LineHeaderPropNames["Tag"] = "tag";
    LineHeaderPropNames["Theme"] = "theme";
})(LineHeaderPropNames || (LineHeaderPropNames = {}));
